import { useState } from 'react'
import { useCookies } from 'react-cookie'
import { useNavigate } from 'react-router-dom'
import dayjs from 'dayjs'

import icon_heart from '@/assets/userPage/userpage_heart.png'
import icon_map from '@/assets/userPage/userpage_map.png'
import icon_msg from '@/assets/userPage/userpage_msg.png'
import nav_letter from '@/assets/userPage/userpage_nav_letter.png'
import nav_unse from '@/assets/userPage/userpage_nav_unse.png'
import icon_person from '@/assets/userPage/userpage_person.png'
import { StorePickerDim } from '@/features/user/main/components/StorePickerDim'
import { TYPE_USERPAGE_INFO } from '@/shared/constant/cmdtype'
import { COLOR } from '@/shared/constant/color'
import { IOS_APP_STORE_WARD, MO_APP_STORE_WARD } from '@/shared/constant/url'
import { UserPageQueryData } from '@/shared/hooks/reactquery'
import useWindowDimensions from '@/shared/hooks/useGetWindowSize'
import { deviceDetection, isDesktopOS } from '@/shared/utils'
import {
  UserPageContents,
  UserPageDirectNavItem,
  UserPageIconBox,
  UserPageInfo,
  UserPageMainPNumber,
  UserPageMainWrap,
} from '@/styles/views/UserPage/main'

const UserMainPage = () => {
  const [cookies] = useCookies(['Famliycare'])
  const { width } = useWindowDimensions()
  const { data: UserPageData, isSuccess } = UserPageQueryData(
    TYPE_USERPAGE_INFO,
    cookies?.Famliycare,
  )
  const UserPNumber = cookies?.Famliycare?.replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`) ?? ''
  const navigate = useNavigate()

  const UserDataList = [
    {
      text: '가입일',
      ImgPath: icon_person,
      data: `${dayjs(UserPageData?.Body?.RegDT).format('YYYY.MM.DD')}`,
    },
    { text: '패밀리레터 수신', ImgPath: icon_msg, data: `${UserPageData?.Body?.LetterCount}건` },
    {
      text: '등록된 안심장소',
      ImgPath: icon_map,
      data: `${UserPageData?.Body?.SafeZoneCount}건`,
      dataZeroText: '안심장소 등록하기',
    },
    {
      text: '패밀리구성원',
      ImgPath: icon_heart,
      data: `${UserPageData?.Body?.FamilyCount}명`,
      dataZeroText: '구성원 초대하기',
    },
  ]
  const [dimIsOpen, setDimIsOpen] = useState(false)

  const toggleDimIsOpen = () => {
    if (!dimIsOpen) {
      if (isDesktopOS()) setDimIsOpen(!dimIsOpen)
      else {
        switch (deviceDetection()) {
          case 'AOS':
            window.open(MO_APP_STORE_WARD)
            break
          case 'IOS':
            window.open(IOS_APP_STORE_WARD)
            break
        }
      }
    } else if (dimIsOpen) setDimIsOpen(!dimIsOpen)
  }

  // useEffect(() => {
  //     if (cookies?.Famliycare === undefined || "") {
  //         navigate("/")
  //     }
  // }, [cookies?.Famliycare, navigate])

  return (
    <>
      <UserPageMainWrap>
        <UserPageMainPNumber>{UserPNumber}</UserPageMainPNumber>
        <UserPageInfo>
          {isSuccess &&
            UserDataList?.map(
              (
                element: {
                  text: string
                  ImgPath: string
                  data: string
                  dataZeroText?: string
                  btnFunc?: () => void
                },
                index: number,
              ) => (
                <UserPageIconBox
                  key={element?.text}
                  border={width > 1200 ? index !== 3 : index === 0 || index === 2}
                >
                  <img src={element?.ImgPath} alt="icon" />
                  {(index === 2 || index === 3) && element?.data.includes('0') ? (
                    <>
                      {width < 1200 && <p>{element?.text}</p>}
                      <button>
                        <a onClick={toggleDimIsOpen}>{element?.dataZeroText}</a>
                      </button>
                    </>
                  ) : (
                    <>
                      <p>{element?.text}</p>
                      <span>{element?.data}</span>
                    </>
                  )}
                </UserPageIconBox>
              ),
            )}
        </UserPageInfo>
        <UserPageContents>
          <UserPageDirectNavItem
            bgColor={COLOR.point1}
            onClick={() => navigate('/userPage/letter/health')}
          >
            <h4>
              읽을수록 <br />
              유익한 정보!
            </h4>
            <span>패밀리레터(헬스, 라이프)를 확인하고 소통해 보세요.</span>
            <img className="letter" src={nav_letter} alt="레터" />
          </UserPageDirectNavItem>
          <UserPageDirectNavItem
            bgColor={COLOR.blueGray8}
            onClick={() => navigate('/userPage/fortune')}
          >
            <h4>
              재미로 보는
              <br />
              오늘의 운세
            </h4>
            <span>하루의 시작을 즐겁게 할 수 있는 오늘의 운세를 확인하고 소통해 보세요.</span>
            <img className="unse" src={nav_unse} alt="운세" />
          </UserPageDirectNavItem>
        </UserPageContents>
      </UserPageMainWrap>
      <StorePickerDim isOpen={dimIsOpen} toggleDimIsOpen={toggleDimIsOpen} />
    </>
  )
}
export default UserMainPage
